import { PieChartOutlined } from "@ant-design/icons";

import { AiFillSetting, AiFillShop } from "react-icons/ai";
import { BiFoodMenu, BiHelpCircle } from "react-icons/bi";
import { FaHubspot, FaListAlt, FaUsers } from "react-icons/fa";
import { GiCook } from "react-icons/gi";
import { GrBike, GrNotification } from "react-icons/gr";
import { MdOutlineAdminPanelSettings } from "react-icons/md";

import AdminAdmin from "../menus/admin_admin";
import AdminPermission from "../menus/admin_permission";
import AdminRole from "../menus/admin_role";

import Support from "../menus/support";

import Allergens from "../menus/allergens";
import Chef from "../menus/chef";
import City from "../menus/city";
import CountryCountry from "../menus/country_country";
import Dashboard from "../menus/dashboard";
import Deliverman from "../menus/deliverman";
import Dietary from "../menus/dietary";
import Discount from "../menus/discount";
import FoodArticle from "../menus/food-article";
import FoodType from "../menus/food-type";
import Geographical from "../menus/geographical";
import GloceryArticle from "../menus/glocery-article";
import gloceryCategory from "../menus/glocery-category";
import GloceryPartner from "../menus/GloceryPartner";
import HelpOrder from "../menus/help-order";
import HubHub from "../menus/hub";
import Ingredient from "../menus/ingredient";
import NotificationEmail from "../menus/notification_email";
import NotificationPush from "../menus/notification_push";
import Order from "../menus/order";
import OrderGlocery from "../menus/order-glocery";
import OrderKanban from "../menus/order-kanban";
import Profil from "../menus/profil";
import Province from "../menus/province";
import Restaurant from "../menus/restaurant";
import Speciality from "../menus/speciality";
import Spicy from "../menus/spicy";
import Template from "../menus/template";
import User from "../menus/user";
import WithdrawalChef from "../menus/withdrawal-chef";
import WithdrawalPartner from "../menus/withdrawal-partner";

const list_menu = [
  {
    value: "dashboard",
    icon: <PieChartOutlined />,
    title: "Dashboard",
    url: "/main",
    component: Dashboard
  },
  {
    value: "admin",
    icon: <MdOutlineAdminPanelSettings />,
    title: "Administrateurs",
    url: "/main/admin",
    children: [
      {
        value: "admin-role",
        title: "Roles",
        url: "/main/admin/role",
        component: AdminRole
      },
      {
        value: "admin-permission",
        title: "Permissions",
        url: "/main/admin/permission",
        component: AdminPermission
      },
      {
        value: "admin-admin",
        title: "Administrateurs",
        url: "/main/admin/list",
        component: AdminAdmin
      }
    ]
  },
  {
    value: "hub",
    icon: <FaHubspot />,
    title: "Hub",
    url: "/main/hub",
    component: HubHub
  },
  {
    value: "glocery",
    icon: <AiFillShop />,
    title: "Épicéries",
    url: "/main/glocery",
    children: [
      {
        value: "glocery-partner",
        title: "Partenaires",
        url: "/main/glocery/partner",
        component: GloceryPartner
      },
      {
        value: "glocery-category",
        title: "Catégories",
        url: "/main/glocery/category",
        component: gloceryCategory
      },
      {
        value: "glocery-item",
        title: "Articles",
        url: "/main/glocery/item",
        component: GloceryArticle
      },
      {
        value: "glocery-order",
        title: "Commandes",
        url: "/main/glocery/list",
        component: OrderGlocery
      },
      {
        value: "glocery-withdrawal",
        title: "Retraits & Paiements",
        url: "/main/glocery/withdrawal",
        component: WithdrawalPartner
      }
    ]
  },
  {
    value: "chef",
    icon: <GiCook />,
    title: "Chefs & Foods",
    url: "/main/chef",
    children: [
      {
        value: "chef-chef",
        title: "Chefs",
        url: "/main/chef/list",
        component: Chef
      },
      {
        value: "chef-restaurant",
        title: "Restaurants",
        url: "/main/chef/restaurant",
        component: Restaurant
      },
      {
        value: "chef-food",
        title: "Plats",
        url: "/main/chef/food",
        component: FoodArticle
      },
      {
        value: "chef-withdrawal",
        title: "Retraits & Paiements",
        url: "/main/chef/withdrawal",
        component: WithdrawalChef
      }
    ]
  },
  {
    value: "user",
    icon: <FaUsers />,
    title: "Utilisateurs",
    url: "/main/user",
    component: User
  },
  {
    value: "deliverman",
    icon: <GrBike />,
    title: "Livreurs",
    url: "/main/deliverman",
    children: [
      {
        value: "deliverman-deliverman",
        title: "Livreurs",
        url: "/main/deliverman/list",
        component: Deliverman
      },
      {
        value: "deliverman-withdrawal",
        title: "Retraits & Paiements",
        url: "/main/deliverman/withdrawal",
        component: () => <>Retrait et paiement</>
      }
    ]
  },
  {
    value: "order",
    icon: <BiFoodMenu />,
    title: "Commandes",
    url: "/main/order",
    children: [
      {
        value: "order-kanban",
        title: "Tableau Kanban",
        url: "/main/order/kanban",
        component: OrderKanban
      },
      {
        value: "order-waiting",
        title: "En attente",
        url: "/main/order/waiting",
        component: () => <Order status={0} />
      },
      {
        value: "order-accepted",
        title: "Accepter",
        url: "/main/order/accepted",
        component: () => <Order status={1} />
      },
      {
        value: "order-onway",
        title: "En chemin",
        url: "/main/order/onway",
        component: () => <Order status={2} />
      },
      {
        value: "order-delivered",
        title: "Livrer",
        url: "/main/order/delivered",
        component: () => <Order status={3} />
      },
      {
        value: "order-canceled",
        title: "Annuler",
        url: "/main/order/canceled",
        component: () => <Order status={4} />
      },
      {
        value: "waiting-refund",
        title: "Attente de Remoursement",
        url: "/main/order/waiting-refund",
        component: () => <Order status={5} />
      },
      {
        value: "order-refunded",
        title: "Rembourser",
        url: "/main/order/refunded",
        component: () => <Order status={6} />
      }
    ]
  },
  {
    value: "content",
    icon: <FaListAlt />,
    title: "Contenus",
    url: "/main/content",
    children: [
      {
        value: "content-allergens",
        title: "Allergies",
        url: "/main/content/allergens",
        component: Allergens
      },
      {
        value: "content-dietary",
        title: "Régime",
        url: "/main/content/dietary",
        component: Dietary
      },
      {
        value: "content-food-type",
        title: "Menus",
        url: "/main/content/food-type",
        component: FoodType
      },
      {
        value: "content-geographical",
        title: "Pays ",
        url: "/main/content/geographical",
        component: Geographical
      },
      {
        value: "content-ingredient",
        title: "Ingrédients",
        url: "/main/content/ingredient",
        component: Ingredient
      },
      {
        value: "content-speciality",
        title: "Les spécialités",
        url: "/main/content/speciality",
        component: Speciality
      },
      {
        value: "content-spicy",
        title: "Niveau d'épice",
        url: "/main/content/spicy",
        component: Spicy
      },
      {
        value: "content-template",
        title: "Template",
        url: "/main/content/template",
        component: Template
      },
      {
        value: "content-tips",
        title: "Tips",
        url: "/main/content/help-order",
        component: HelpOrder
      }
    ]
  },
  {
    value: "support",
    icon: <BiHelpCircle />,
    title: "Support",
    url: "/main/support",
    children: [
      {
        value: "support-user",
        title: "Utilisateurs",
        url: "/main/support/user",
        component: () => <Support type="user" />
      },
      {
        value: "support-chef",
        title: "Chefs",
        url: "/main/support/chef",
        component: () => <Support type="chef" />
      },
      {
        value: "support-deliverman",
        title: "Livreurs",
        url: "/main/support/deliverman",
        component: () => <Support type="deliverman" />
      },
      {
        value: "support-deliverman",
        title: "Épiceries",
        url: "/main/support/partner",
        component: () => <Support type="partner" />
      }
    ]
  },
  {
    value: "notification",
    icon: <GrNotification />,
    title: "Promo & Messagerie",
    url: "/main/notification",
    children: [
      {
        value: "notification-discount",
        title: "Promotions",
        url: "/main/notification/discount",
        component: Discount
      },
      {
        value: "notification-email",
        title: "Push Email",
        url: "/main/notification/email",
        component: NotificationEmail
      },

      {
        value: "notification-push",
        title: "Push Message",
        url: "/main/notification/push",
        component: NotificationPush
      }
    ]
  },
  {
    value: "setting",
    icon: <AiFillSetting />,
    title: "Paramètres",
    url: "/main/setting",
    children: [
      {
        value: "setting-country",
        title: "Pays",
        url: "/main/setting/country",
        component: CountryCountry
      },
      {
        value: "setting-province",
        title: "Province",
        url: "/main/setting/province",
        component: Province
      },
      {
        value: "setting-city",
        title: "Ville",
        url: "/main/setting/city",
        component: City
      },
      {
        value: "setting-profil",
        title: "Mon profil",
        url: "/main/setting/profil",
        component: Profil
      }
    ]
  }
];

export { list_menu };
